import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IrisMsalService } from '@iris/modules/msal/msal.service';
import { AuthFacade } from '@iris/modules/auth/utils/auth.facade';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { SkModalContentComponent } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-version-check',
  imports: [
    TranslatePipe,
    StrakitButtonComponent,
    SkModalContentComponent,
  ],
  templateUrl: './version-check.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionCheckComponent {

  dialogRef = inject(MatDialogRef);
  authFacade = inject(AuthFacade);
  msalService = inject(IrisMsalService);

  continueNavigation(): void {
    sessionStorage.setItem('skipVersionModal', 'true');
    this.dialogRef.close();
  }

  logoutAndRefresh(): void {
    this.authFacade.logout(true);
    this.msalService.removeActiveAccount();
  }
}
